/*  MUI  */
import {
    Box, // Autocomplete,
    Button,
    CircularProgress,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

/*  Shared  */
import { MultiInput } from 'application/Shared/Components/Inputs';
import { Notify, Response } from 'application/Shared/Helpers';
// import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';
import dayjs from 'dayjs';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Add extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // apps: [],
            breach: {
                applicationId: '',
                dateAnnounced: new Date(),
                description: '',
                nistId: 'N/A',
                resources: [],
                severityScore: 0,
                steps: [],
                type: 'manual'
            },
            loaded: false,
            // loadingApps: false,
            saving: false
        };

        /* requests */
        // this.requests = new Requests();
    }

    componentDidMount() {
        // this.load();
        this.setState({ loaded: true });
    }

    // TODO: Uncomment when we figure out the dropdown with 100K entries not all at once.
    // componentWillUnmount() {
    //     this.unload();
    // }

    // load = () => {
    //     this.loadApps();
    // };

    // unload = () => {
    //     this.unmounted = true;
    //     this.requests.cancel();
    // };

    // loadApps = async () => {
    //     try {
    //         this.setState({ loadingApps: true });
    //         const response = await axios.get('/application', {
    //             params: { name: '*', nameAndIdOnly: true, size: -1 },
    //             cancelToken: this.requests.token()
    //         });

    //         if (!Response.hasData(response)) {
    //             debug.w('No Apps Found', response);
    //             if (!this.unmounted) {
    //                 this.setState({ loaded: true });
    //             }
    //         }

    //         const data = Response.getData(response);
    //         const apps = data?.sort((a, b) =>
    //             `${a.name}`.localeCompare(b.name)
    //         );

    //         if (!this.unmounted) {
    //             this.setState({ apps, loadingApps: false });
    //         }
    //     } catch (e) {
    //         debug.e('Error getting Global Apps', e);
    //     }
    // };

    addBreach = async () => {
        /* init */
        const err = 'Could not add Vendor Incident';

        /* props | state */
        const { t, handleTabChange } = this.props;
        const { breach } = this.state;

        const { resources } = breach;
        delete breach.resources;

        try {
            this.setState({ saving: true });
            const response = await axios.post('/breach/', breach);
            if (!Response.hasData(response)) {
                debug.e(err, response);
                Notify.e(err);
                this.setState({ saving: false });
                return;
            }

            const breachId = Response.getId(response);

            resources.forEach(async (resource) => {
                const { url } = resource;
                if (!url) {
                    return;
                }

                const augmentedResource = { ...resource, breachId };

                try {
                    await axios.post('/breachSource', augmentedResource);
                } catch (e) {
                    debug.e(e);
                    Notify.e(`Failed to add Resource '${url}'`);
                    this.setState({ saving: false });
                }
            });

            Notify.s(t('Vendor Security Event added'));
            handleTabChange('list');
        } catch (e) {
            debug.e('Error adding Vendor Security Event', e);
            Notify.e(err);
        }
        this.setState({ saving: false });
    };

    renderNIST = () => {
        const { breach } = this.state;
        return (
            <Grid
                item
                xs={12}
                style={{ padding: '4px', paddingBottom: '20px' }}
            >
                <Typography color="textSecondary" fontWeight={600}>
                    NIST ID
                </Typography>
                <br />
                <TextField
                    fullWidth
                    onChange={(e) =>
                        this.setState({
                            breach: { ...breach, nistId: e.target.value }
                        })
                    }
                    value={breach.nistId}
                />
            </Grid>
        );
    };

    renderDateAnnounced = () => {
        const { breach } = this.state;

        return (
            <Grid
                item
                xs={12}
                style={{ padding: '4px', paddingBottom: '20px' }}
            >
                <Typography color="textSecondary" fontWeight={600}>
                    Date Announced
                </Typography>
                <br />
                <DatePicker
                    value={dayjs(breach.dateAnnounced)}
                    onChange={(e) =>
                        this.setState({
                            breach: { ...breach, dateAnnounced: new Date(e) }
                        })
                    }
                />
            </Grid>
        );
    };

    renderDescription = () => {
        const { t } = this.props;
        const { breach } = this.state;

        return (
            <Grid
                item
                xs={12}
                style={{ padding: '4px', paddingBottom: '20px' }}
            >
                <Typography color="textSecondary" fontWeight={600}>
                    {t('Common.description')}
                </Typography>
                <br />
                <TextField
                    fullWidth
                    onChange={(e) =>
                        this.setState({
                            breach: {
                                ...breach,
                                description: e.target.value
                            }
                        })
                    }
                    value={breach.description}
                    multiline
                />
            </Grid>
        );
    };

    renderSeverity = () => {
        const { breach } = this.state;
        return (
            <Grid
                item
                xs={12}
                style={{ padding: '4px', paddingBottom: '20px' }}
            >
                <Typography color="textSecondary" fontWeight={600}>
                    Severity Score (0-10)
                </Typography>
                <br />
                <TextField
                    type="number"
                    fullWidth
                    onChange={(e) =>
                        this.setState({
                            breach: {
                                ...breach,
                                severityScore: e.target.value
                            }
                        })
                    }
                    value={breach.severityScore}
                />
            </Grid>
        );
    };

    renderApplication = () => {
        const { t } = this.props;
        // const { apps, breach, loadingApps } = this.state;
        const { breach } = this.state;

        return (
            <Grid
                item
                xs={12}
                style={{ padding: '5px', paddingBottom: '20px' }}
            >
                {/* <Autocomplete
                    popupIcon={<ExpandMore />}
                    id="app-id-auto"
                    loading={loadingApps}
                    loadingText={t('VendorIncident.search_app.loading')}
                    onChange={(event, newValue) => {
                        this.setState({
                            breach: {
                                ...breach,
                                applicationId: newValue?.id
                            }
                        });
                    }}
                    options={apps}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                        <Box {...props} key={option.id}>
                            {option.name}
                        </Box>
                    )}
                    openOnFocus
                    style={{ width: '100%' }}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '300px'
                            }
                        },
                        popper: {
                            placement: 'bottom-start'
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t('VendorIncident.search_app')}
                        />
                    )}
                />
                <Typography style={{ marginTop: '11px' }}>
                    <Typography
                        color="textSecondary"
                        fontWeight={600}>{t('Common.application_id')}:</Typography>{' '}
                    {breach.applicationId}
                </Typography> */}
                <Typography color="textSecondary" fontWeight={600}>
                    {t('Common.application_id')}:
                </Typography>
                <br />
                <TextField
                    fullWidth
                    onChange={(e) =>
                        this.setState({
                            breach: {
                                ...breach,
                                applicationId: e.target.value
                            }
                        })
                    }
                    value={breach.applicationId}
                />
            </Grid>
        );
    };

    renderSources = () => {
        const { t } = this.props;
        const { breach } = this.state;

        return (
            <Grid
                item
                xs={12}
                style={{ padding: '4px', paddingBottom: '20px' }}
            >
                <Typography color="textSecondary" fontWeight={600}>
                    {t('Common.sources')}
                </Typography>

                <MultiInput
                    fields={[
                        { field: 'type', label: 'Type' },
                        { field: 'url', label: 'URL' }
                    ]}
                    key="renderSources"
                    max={5}
                    min={0}
                    onChange={(p) => {
                        this.setState({
                            breach: {
                                ...breach,
                                resources: p.rows.map((a) => ({
                                    type: [a.type],
                                    url: a.url
                                }))
                            }
                        });
                    }}
                    values={breach.resources}
                    zeroText="Add Source"
                />
            </Grid>
        );
    };

    renderSteps = () => {
        const { t } = this.props;
        const { breach } = this.state;

        return (
            <Grid
                item
                xs={12}
                style={{ padding: '4px', paddingBottom: '20px' }}
            >
                <Typography color="textSecondary" fontWeight={600}>
                    {t('Common.suggested_steps')}
                </Typography>

                <MultiInput
                    fields={[{ field: 'step', label: 'Step' }]}
                    key="renderSteps"
                    max={5}
                    min={0}
                    onChange={(p) => {
                        this.setState({
                            breach: {
                                ...breach,
                                steps: p.rows.map((a) => a.step)
                            }
                        });
                    }}
                    values={breach.steps}
                    zeroText="Add Suggested Step"
                />
            </Grid>
        );
    };

    render() {
        const { t } = this.props;
        const { breach, loaded, saving } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <Grid container>
                {this.renderNIST()}
                {this.renderDateAnnounced()}
                {this.renderDescription()}
                {this.renderSeverity()}
                {this.renderApplication()}
                {this.renderSources()}
                {this.renderSteps()}
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    width="100%"
                >
                    {saving && <CircularProgress size="32px" />}
                    <Button
                        disabled={!breach.applicationId || saving}
                        onClick={() => this.addBreach()}
                        color="primary"
                        variant="contained"
                        style={{ marginLeft: '8px' }}
                    >
                        {t('Common.add')}
                    </Button>
                </Box>
            </Grid>
        );
    }
}
export default withTranslation()(Add);
